import ImageOptimizer from '@/components/image-optimizer';
import { ReviewType } from '@/types/review.type';

interface Props {
  review: ReviewType[];
}

const BranchReviewList = ({ review }: Props) => {
  // console.log(review);
  return (
    <div className="desktop:min-h-[428px] flex flex-col gap-4">
      {review.slice(0, 3).map((review, idx) => (
        <div
          key={review.id || idx}
          className="bg-bg-graylight justify-centerrounded-xl flex h-[112px] items-center rounded-xl p-5"
        >
          <ImageOptimizer
            src={
              review.images?.[0]?.filePath ??
              '/images/branches/branch_review.png'
            }
            alt="리뷰 이미지"
            width={80}
            height={80}
            className="mr-4 h-[80px] w-[80px] rounded-xl"
            loading="eager"
          />
          <div className="flex flex-1 flex-col justify-center">
            <div className="text-level-1 typo-16 desktop:typo-18 w-full pb-4 font-bold">
              {review.reviewer}
            </div>
            {/* 리뷰 내용 */}
            <p className="text-level-4 typo-14 line-clamp-2 w-full leading-[22px] font-semibold">
              {review.content}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BranchReviewList;
